import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet/dist/leaflet.css'
import CircleMarker from './Marker'

function Map (props) {
  const { locationInfo } = props
  const { longitude: lng, latitude: lat } = locationInfo || {}
  const [position, setPosition] = useState({ lat: 23.723876, lng: 120.872141 })

  useEffect(() => {
    if (lng && lat) setPosition({ lat, lng })
  }, [locationInfo])

  const passProps = {
    ...props,
    position,
    setPosition
  }
  return (
    <>
      <MapContainer center={position} zoom={7}>
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <CircleMarker {...passProps} />
    </MapContainer>
    </>
  )
}

export default Map
